import React, { useEffect } from 'react';
import { TrustBar } from '../components/TrustBar';
import { HeroSection } from '../components/HeroSection';
import { AgitationSection } from '../components/AgitationSection';
import { VillainSection } from '../components/VillainSection';
import { SolutionSection } from '../components/SolutionSection';
import { BundleSection } from '../components/BundleSection';
import { TestimonialGrid } from '../components/TestimonialGrid';
import { Footer } from '../components/Footer';
import { StickyButton } from '../components/StickyButton';
import { initMetaPixel } from '../utils/metaPixel';
export function LandingPage() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <main className="min-h-screen w-full bg-white selection:bg-mint-light selection:text-deep-blue relative" data-id="element-151">
      <TrustBar data-id="element-152" />
      <HeroSection data-id="element-153" />
      <AgitationSection data-id="element-154" />
      <VillainSection data-id="element-155" />
      <SolutionSection data-id="element-156" />
      <BundleSection data-id="element-157" />
      <TestimonialGrid data-id="element-158" />
      <Footer data-id="element-159" />
      <StickyButton data-id="element-160" />
    </main>;
}